import { treemapExtensionInstall } from './treemap';

export default [treemapExtensionInstall];
